function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Animated, Easing, Platform } from 'react-native';
import { Animation } from "../animation/animation";
const PI = 180;
const PI2 = 360;
const OFFSET_MIN = PI / 12;
const OFFSET_MAX = PI / 6;
const BaseBezierEasing = Easing.bezier(0.4, 0.0, 0.7, 1.0);

const StartArcEasing = progress => {
  return -PI + OFFSET_MIN + (PI - OFFSET_MAX) * BaseBezierEasing(progress);
};

const EndArcEasing = progress => {
  return PI2 - OFFSET_MIN + (-PI + OFFSET_MAX) * BaseBezierEasing(progress);
};

const DEFAULT_CONFIG = {
  duration: 2400,
  easing: Easing.linear,
  cycles: -1,
  useNativeDriver: Platform.OS !== 'web'
};

/**
 * Animates a Spinner in a Material Design way.
 *
 * Thanks these guys for open sourcing the algorithm: https://github.com/n4kz/react-native-indicators
 */
export class SpinnerAnimation extends Animation {
  constructor(arcSize, config) {
    super(_objectSpread(_objectSpread({}, DEFAULT_CONFIG), config));

    _defineProperty(this, "animationValue", void 0);

    _defineProperty(this, "animationFrames", void 0);

    _defineProperty(this, "arcSize", void 0);

    _defineProperty(this, "createFrameRange", duration => {
      const numberOfFrames = 60 * duration / 1000;
      return new Array(numberOfFrames).fill(0);
    });

    _defineProperty(this, "createContainerInterpolation", () => {
      return this.animationValue.interpolate({
        inputRange: [0, 1],
        outputRange: [this.toDegValue(OFFSET_MAX + OFFSET_MIN), this.toDegValue(2 * PI2 + OFFSET_MAX + OFFSET_MIN)]
      });
    });

    _defineProperty(this, "createArcInterpolation", easing => {
      return this.animationValue.interpolate({
        inputRange: this.createArcInterpolationInputRange(),
        outputRange: this.createArcInterpolationOutputRange(easing)
      });
    });

    _defineProperty(this, "createArcInterpolationInputRange", () => {
      return this.animationFrames.map((item, frame) => {
        return frame / (this.animationFrames.length - 1);
      });
    });

    _defineProperty(this, "createArcInterpolationOutputRange", easing => {
      return this.animationFrames.map((item, frame) => {
        const progress = 2 * frame / (this.animationFrames.length - 1);
        const boundedProgress = Math.min(2.0 - progress, progress);
        return this.toDegValue(easing(boundedProgress));
      });
    });

    _defineProperty(this, "toStyleTransformProp", (rotate, source = {}) => {
      const transform = [...(source.transform || []), {
        rotate
      }]; // @ts-ignore: AnimatedInterpolation does not fit RotateTransform type declaration

      return _objectSpread(_objectSpread({}, source), {}, {
        transform
      });
    });

    _defineProperty(this, "toDegValue", source => {
      return `${source}deg`;
    });

    this.arcSize = arcSize;
    this.animationValue = new Animated.Value(0);
    this.animationFrames = this.createFrameRange(this.config.duration);
  }

  get animation() {
    return Animated.timing(this.animationValue, _objectSpread({
      toValue: 1.0
    }, this.config));
  }

  start(callback) {
    // reset animation value before the next animation cycle
    this.animationValue.setValue(0);
    super.start(callback);
  }

  stop() {
    super.stop();
    this.animationValue.setValue(0);
  }
  /**
   * @returns {SpinnerAnimationStyle} - an object that contains container, start and end arcs transform styles.
   */


  toProps() {
    const containerInterpolation = this.createContainerInterpolation();
    const startArcInterpolation = this.createArcInterpolation(StartArcEasing);
    const endArcInterpolation = this.createArcInterpolation(EndArcEasing);
    return {
      container: this.toStyleTransformProp(containerInterpolation),
      start: this.toStyleTransformProp(startArcInterpolation),
      end: this.toStyleTransformProp(endArcInterpolation, {
        transform: [{
          translateY: -this.arcSize / 2
        }]
      })
    };
  }
  /**
   * @param {number} duration - animation duration.
   * @returns an array of frames fitted into animation.
   */


}